
const BASE_URL = 'https://api.coinnexs.com/api';

export interface UserTrade {
    tradeId: string;
    asset: string;
    principal: string;
    outcome: 'PROFIT' | 'LOSS' | 'PENDING' | 'DEPOSIT';
    payout: string;
    executedAt: string;
}

export interface UserTradeResponse {
    success: boolean;
    data: UserTrade[];
    pagination?: {
        total: number;
        page: number;
        pages: number;
    };
}

class UserTradeService {
    private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
        const token = localStorage.getItem('coinnexs_token');
        const headers: Record<string, string> = {
            ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            'Content-Type': 'application/json',
            ...(options.headers as Record<string, string>),
        };

        try {
            const response = await fetch(`${BASE_URL}${endpoint}`, {
                ...options,
                headers,
            });

            const data = await response.json();
            return data as T;
        } catch (error) {
            console.error(`User Trade API Error (${endpoint}):`, error);
            throw error;
        }
    }

    async listTrades(params: { page?: number; limit?: number; outcome?: string } = {}): Promise<UserTradeResponse> {
        const query = new URLSearchParams();
        if (params.page) query.append('page', params.page.toString());
        if (params.limit) query.append('limit', params.limit.toString());
        if (params.outcome) query.append('outcome', params.outcome);

        const endpoint = `/trades${query.toString() ? `?${query.toString()}` : ''}`;
        return this.request<UserTradeResponse>(endpoint);
    }
}

export const userTradeService = new UserTradeService();
